import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Detail from "../pages/detail/page";
import Category from "../pages/category/page";
import About from "../pages/about/page";
import Faq from "../pages/faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/comic/:id",
    element: <Detail />,
  },
  {
    path: "/category",
    element: <Category />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/faq",
    element: <Faq />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;